module.exports = __webpack_public_path__ + "static/media/apple-store-btn.08e794af.svg";